import { formatDisplayTime, formatDateReadable } from '../../utils/time-converter'

/* ─── Date helpers ──────────────────────────────────────────────────────────── */
export const isSessionPast = (sessionDate) => new Date(sessionDate) < new Date(new Date().toDateString())
export const isSessionUpcoming = (sessionDate) => new Date(sessionDate) >= new Date(new Date().toDateString())

/* ─── Time formatting (24hr → 12hr) ────────────────────────────────────────── */
export const fmtTime = (t) => {
    if (!t) return ''
    return formatDisplayTime(t.substring(0, 5))
}

export const fmtTimeRange = (start, end) => {
    const s = fmtTime(start)
    const e = fmtTime(end)
    if (!s) return ''
    return e ? `${s} – ${e}` : s
}

export const fmtDate = (dateStr) => dateStr ? formatDateReadable(dateStr) : ''

/* ─── Parse metadata safely ─────────────────────────────────────────────────── */
export const parseMetadata = (metadata) => {
    if (!metadata) return null
    try {
        return typeof metadata === 'string' ? JSON.parse(metadata) : metadata
    } catch {
        return null
    }
}

/* ─── Enrollment status badge classes ───────────────────────────────────────── */
export const enrollmentStatusBadge = (status) => {
    const map = {
        enrolled:  'bg-indigo-100 text-indigo-700',
        attended:  'bg-emerald-100 text-emerald-700',
        missed:    'bg-red-100 text-red-700',
        cancelled: 'bg-gray-100 text-gray-500',
    }
    return map[status] || map.enrolled
}
